<div class="star-rating-container">
  <div *ngFor="let star of stars;" [ngStyle]="{'color': colour}" [ngClass]="{'hubtiger-star-outline': rating < star, 'hubtiger-star-half': isDecimal(rating) && round(rating) === star, 'hubtiger-star-fill': rating >= star}"></div>
</div>  